/* global previews */
export function updateSelectedObject(fabric, canvas, groups, currentTarget, groupFields) {
    groups.forEach((group) => {
        groupFields.remove(group.id);
        group.forEachObject((obj) => {
          const matrix = group.calcTransformMatrix();
          const finalPosition = fabric.util.transformPoint({ x: obj.left, y: obj.top }, matrix);

          group.remove(obj)

          const objClone = _.cloneDeep(obj);
          objClone.set({
            left: finalPosition.x,
            top: finalPosition.y,
            scaleX: obj.scaleX * currentTarget.scaleX,
            scaleY: obj.scaleY * currentTarget.scaleY,
          })
          currentTarget.removeWithUpdate(group);
          canvas.remove(group);
          currentTarget.addWithUpdate(objClone);
        });
    })
}

export function getAllObjects(objects = []) {
    let newObjects = [];
    let groups = [];

    for (let i = 0; objects.length > i; i++) {
        const item = objects[i];

        if (item.get('type') === 'group') {
        groups.push(item);
        const data = getAllObjects(item.getObjects());
        
        groups = [...groups, ...data.groups];
        newObjects = [...newObjects, ...data.objects];

        } else if (!item._objects) {
        newObjects.push(item);
        }
    }

    return { objects: newObjects, groups };
}

export function getImageFromGroupForPublish(instanceId, indexOfGroup = undefined, ) {
  const imageOptions = {
    format: 'png', 
    quality: 0.1
  }
  if (!instanceId) throw 'Please provide the preview instance ID!';
  const preview = previews.find(preview => preview.id === instanceId);
  if(!preview) throw 'No previews found with the specified instance ID!';
  const canvas = preview.canvas;
  const groups = canvas.getObjects('group');
  if (!groups.length) throw 'No groups found!';
  if (groups.length === 1) {
    return groups[0].toDataURL(imageOptions);
  }
  if (groups.length > 1 && indexOfGroup === undefined) throw 'Group index not specified!';
  return groups[indexOfGroup].toDataURL(imageOptions);
}